import { render, staticRenderFns } from "./StepContent.vue?vue&type=template&id=becca822"
import script from "./StepContent.vue?vue&type=script&lang=js"
export * from "./StepContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports